import { render, staticRenderFns } from "./FaqsList.vue?vue&type=template&id=2cae71d4&"
import script from "./FaqsList.vue?vue&type=script&lang=js&"
export * from "./FaqsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports